module.exports = __webpack_public_path__ + "static/media/B2C.08d8db10.png";